import { render, staticRenderFns } from "./ApproveProofButton.vue?vue&type=template&id=02b535c9&"
import script from "./ApproveProofButton.vue?vue&type=script&lang=js&"
export * from "./ApproveProofButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports